<template>
  <div id="components-modal-demo-position">
    <a-modal
      centered
      :visible="true"
      title="新增用户"
      :footer="null"
      @cancel="cancel"
      class="addForm"
    >
      <a-form-model
        ref="ruleForm"
        :model="params"
        :rules="rules"
        class="joinForm"
        v-bind="layout"
      >
        <a-form-model-item ref="userName" label="用户名" prop="userName">
          <a-input
            placeholder="用户名"
            v-model="params.userName"
            @blur="
              () => {
                $refs.userName.onFieldBlur()
              }
            "
          />
        </a-form-model-item>
        <a-form-model-item ref="email" label="邮箱" prop="email">
          <a-input
            placeholder="邮箱"
            v-model="params.email"
            @blur="
              () => {
                $refs.email.onFieldBlur()
              }
            "
          />
        </a-form-model-item>
        <a-form-model-item ref="phonenumber" label="手机" prop="phonenumber">
          <a-input
            placeholder="手机"
            v-model="params.phonenumber"
            @blur="
              () => {
                $refs.phonenumber.onFieldBlur()
              }
            "
          />
        </a-form-model-item>
        <a-form-model-item ref="enpName" label="机构" prop="enpName">
          <a-input
            placeholder="机构"
            v-model="params.enpName"
            @blur="
              () => {
                $refs.enpName.onFieldBlur()
              }
            "
          />
        </a-form-model-item>
        <a-form-model-item ref="password" label="密码" prop="password">
          <a-input
            placeholder="密码"
            v-model="params.password"
            type="password"
          />
        </a-form-model-item>
        <a-form-model-item
          ref="passwordTwo"
          label="确认密码"
          prop="passwordTwo"
        >
          <a-input
            placeholder="再次确认密码"
            v-model="params.passwordTwo"
            type="password"
          />
        </a-form-model-item>
      </a-form-model>
      <div class="btnClass">
        <a-button @click="cancel" class="cancel commonBtn">取消</a-button>
        <a-button type="primary" class="commonBtn" @click="confirmClick"
          >确认</a-button
        >
      </div>
    </a-modal>
  </div>
</template>
<script>
var reg = new RegExp(
  '^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\\d{8}$'
) // 校验手机号
import { addUser } from '@/api/accountInfos'
export default {
  props: {},
  data() {
    return {
      Visible: true,
      params: {
        userName: '',
        email: '',
        phonenumber: '',
        enpName: '',
        password: '',
        passwordTwo: ''
      },
      rules: {
        userName: [
          { required: true, message: '请输入用户名!', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入邮件!', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱!' }
        ],
        phonenumber: [
          { required: true, message: '请输入手机号!', trigger: 'blur' },
          {
            validator: (rule, val, callback) => {
              if (!reg.test(val)) {
                callback(new Error('请输入正确的手机号!'))
              } else {
                callback()
              }
            }
          }
        ],
        enpName: [
          { required: true, message: '请输入企业名称!', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码!', trigger: 'blur' },
          {
            validator: this.validateToNextPassword
          }
        ],
        passwordTwo: [
          { required: true, message: '请输入再次密码!', trigger: 'blur' },
          {
            validator: this.compareToFirstPassword
          }
        ]
      },
      layout: {
        labelCol: { span: 5 },
        wrapperCol: { span: 18 }
      },
      confirmDirty: false
    }
  },
  mounted() {},
  methods: {
    handleCancel() {
      this.$emit('cancelVisible', false)
    },
    cancel() {
      this.$emit('cancel')
    },
    confirmClick() {
      if (this.params.password !== this.params.passwordTwo) {
        this.$message.warning('两次输入的密码不相同!')
        return
      }
      let isBreak = false
      for (let key in this.params) {
        if (this.params[key] === '' && !isBreak) {
          isBreak = true
          this.$message.warning('请完善信息!')
          return
        }
      }
      addUser(this.params).then(res => {
        if (res.code === 200) {
          this.$message.success('新增成功!')
          this.$emit('addSuccess')
        } else {
          this.$message.warning(res.msg)
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped></style>
